import { __assign, __makeTemplateObject } from "tslib";
import React, { useCallback } from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { CloseIcon } from '../../icons/draft';
import { Paper } from '../Paper/Paper';
import { Button } from '../Button/Button';
import { MessageBarContextProvider } from './MessageBarContext';
import { messageBarPalette } from './palette';
import { MessageBarTitle } from './MessageBarTitle';
import { MessageBarText } from './MessageBarText';
import { extractAriaAttributes } from '../internal/extract-props/extractAriaAttributes';
import { extractDataAttributes } from '../internal/extract-props/extractDataAttributes';
import { getFixedSpacing } from '../../theme/Spacing/Spacing';
var CloseButton = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return (React.createElement(SCloseButton, { variant: "text", onClick: onClick, className: className },
        React.createElement(CloseIcon, { color: "black", size: "xs" })));
};
var SCloseButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n"])), getFixedSpacing(0.5), getFixedSpacing(0.5));
export var MessageBar = function (props) {
    var ariaAttributes = extractAriaAttributes(props).ariaAttributes;
    var dataAttributes = extractDataAttributes(props).dataAttributes;
    var variant = props.variant, onClose = props.onClose, closeButtonStyles = props.closeButtonStyles, children = props.children;
    var _a = messageBarPalette[variant || 'alert'], backgroundColor = _a.backgroundColor, border = _a.border;
    var handleCloseClick = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        onClose && onClose(event);
    }, [onClose]);
    return (React.createElement(Box, __assign({}, ariaAttributes, dataAttributes),
        React.createElement(Paper, { backgroundColor: backgroundColor, borderColor: border, elevation: 0 },
            React.createElement(Box, { position: "relative" },
                onClose && (React.createElement(CloseButton, { className: closeButtonStyles, onClick: handleCloseClick })),
                React.createElement(Box, { px: 1, pt: 1.5, mb: 1.5 },
                    React.createElement(MessageBarContextProvider, { value: variant }, children))))));
};
MessageBar.Title = MessageBarTitle;
MessageBar.Text = MessageBarText;
var templateObject_1;
//# sourceMappingURL=MessageBar.js.map